import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import { errorConditionGTM } from "../../../Utils/googleTags";
import ApiUrls from "../../../Utils/axr";

type changePlanDetailsInitialStateType = {
  changePlanPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: changePlanDetailsInitialStateType = {
  changePlanPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = "change-my-plan.json";

export const getChangePlanPageContent = createAsyncThunk(
  "get/changePlan-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}&v=1`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const changePlanDetailSlice = createSlice({
  name: "changePlan-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getChangePlanPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getChangePlanPageContent.fulfilled, (state, action) => {
      state.changePlanPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getChangePlanPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "Change Plan content",
        action.error?.message,
        action?.type
      );
      state.changePlanPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default changePlanDetailSlice.reducer;
